package br.com.texeratx.boardgametimeapp.ui.navigation

import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class AppStartViewModel(
    private val sessionManager: SessionManager
) : ScreenModel {

    private val _startDestination = MutableStateFlow<StartDestination?>(null)
    val startDestination: StateFlow<StartDestination?> = _startDestination

    init {
        screenModelScope.launch {
            val session = sessionManager.load()
            _startDestination.value = when {
                session == null || session.token.isBlank() -> {
                    Napier.d("AppStart → sem sessão, indo para Login")
                    StartDestination.Login
                }
                session.activeClanId == null -> {
                    Napier.d("AppStart → sessão sem clã ativo, indo para MyClans")
                    StartDestination.MyClans
                }
                else -> {
                    Napier.d("AppStart → sessão completa, indo para Home")
                    StartDestination.Home
                }
            }
        }
    }
}

enum class StartDestination {
    Login, MyClans, Home
}
